var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-door",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M30.917,9.019V28.9A2.021,2.021,0,0,1,28.9,30.917H17.725l.064-21.583H9.333v19.25h6.714v2.333H9.019A2.021,2.021,0,0,1,7,28.9V9.019A2.021,2.021,0,0,1,9.019,7h11.11l-.064,21.583h8.519V9.333H21.727V7H28.9A2.021,2.021,0,0,1,30.917,9.019ZM12.679,19.585l2.036,2.073V16.235l-2.039,2.086A.908.908,0,0,0,12.679,19.585Zm12.5-1.264-2.038-2.085v5.423l2.035-2.072A.909.909,0,0,0,25.175,18.32Z",
    transform: "translate(-4.958 -4.958)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDoor);
export default __webpack_public_path__ + "static/media/ico-door.37282abe11fa533cfb7e49f49734e139.svg";
export { ForwardRef as ReactComponent };